import Lenis from 'lenis';
import { object } from './_obj.js';
import { loadPost } from './_loadPost.js';

let Block = {
	top: 0,
	show: 0
}

let $this;

export let scroll = {
	lenis: null,
	position: [0, 0],
	observer: null,
	loadObserver: null,
	videoObserver: null,
	currentPage: "",
	isPage: "",
	init: function(){
		this.start();
	},
	reset: function(){
		let s = scroll;
		s.lenis = null;
		if( s.observer ){
			s.observer.disconnect();
		}
		if(s.loadObserver){
			s.loadObserver.disconnect();
		}
		if( s.videoObserver ){
			s.videoObserver.disconnect();
		}
		s.currentPage = document.querySelector("body").getAttribute("data-page-category");
	},
	start: function(){
		let s = scroll;
		s.reset();
		s.lenis = new Lenis();
		//console.log(s.lenis);
		
		this.lenis.on('scroll', (e) => {
			s.position[0] = e.animatedScroll;
			s.position[1] = s.position[0] + window.innerHeight;
			
			s.checkScroll();
		});
		function raf(time) {
			if(s.lenis){
				s.lenis.raf(time);
			}
			requestAnimationFrame(raf)
		}
		requestAnimationFrame(raf);
		s.nav();
		s.setObserver( null );
		//console.log("here");
		s.setModalDetail();
	},
	stopPropagation: function(e){
		e.stopPropagation();
	},
	stop: function(){
		
	},
	nav: function(){
		let $this = this;
		let $navs = document.querySelectorAll(".c-nav_philosophy li a");
		if($navs){
			$navs.forEach( ($n) => {
				$n.removeEventListener("click", {name: this, handleEvent: scroll.goToPos}, false);
				$n.addEventListener("click", {name: this, handleEvent: scroll.goToPos}, false);
			});
		}
	},
	setModalDetail: function(){
		let s = scroll;
		//console.log("stop propagation");
		
		let $modalInner = document.querySelector(".b-detail_inner");
		if( $modalInner ){
			$modalInner.removeEventListener("wheel", s.stopPropagation, false);
			$modalInner.addEventListener("wheel", s.stopPropagation, false);
		}
	},
	setObserver: function( root ){
		let $this = scroll;
		let $animates = document.querySelectorAll("[data-animate]");
		if( $animates ){
			//DOMにdata-repeat="1"で画面外にいったときにanimateのclassを削除
			let AnimateOptions = {
				root: root ? root : null,
				rootMargin: "-25% 0px",
				threshold: 0
			}
			//data-animate用observer
			$this.observer = new IntersectionObserver($this.checkAnimate, AnimateOptions);
			//console.log($animates, AnimateOptions, $this.observer);
			$animates.forEach( item => {
				$this.observer.observe(item);
			});
		}
		//other observer
		if( scroll.currentPage === "works" || scroll.currentPage === "magazine" || scroll.currentPage === "news" ){
			let $footer = document.querySelectorAll("footer#g-footer");
			let rMargin = window.innerHeight*-.5;
			//console.log(rMargin)
			if( $footer.length > 0 ){
				let FooterOptions = {
					root: null,
					rootMargin: `0px 0px 0px 0px`,
					threshold: 0
				}
				$this.loadObserver = new IntersectionObserver(scroll.checkLoad, FooterOptions);
				$footer.forEach( item => {
					$this.loadObserver.observe(item);
				});
			}
		}
		if( scroll.currentPage === "philosophy" ){
			setTimeout(function(){
				let $animates = document.querySelectorAll("[data-slide] .c-col2_l");
				if( $animates ){
					//DOMにdata-repeat="1"で画面外にいったときにanimateのclassを削除
					let PhilosophyOptions = {
						root: null,
						rootMargin: "-40% 0px -40% 0px",
						threshold: 0
					}
					//data-animate用observer
					$this.observer = new IntersectionObserver($this.checkPhilosophy, PhilosophyOptions);
					//console.log($animates, AnimateOptions, $this.observer);
					$animates.forEach( item => {
						$this.observer.observe(item);
					});
				}
			}, 2000);
		}
	},
	checkLoad(){
		console.log(scroll.currentPage, "check load")
		let $body = document.querySelector("body");
		if( !$body.classList.contains("change_page") ){
			if( !$body.classList.contains("is_tag") ){
				loadPost.nextPage();
			}
		}
	},
	checkAnimate(items){
		items.forEach( (item) => {
			if( item.isIntersecting ){
				//console.log("interSectiong:", item.target);
				startAnimate( item.target );
			}else{
				if( item.target.getAttribute("data-repeat") === "1" ){
					deleteAnimate(item.target);
					
				}
			}
		});
		
		function startAnimate( $target ){
			if( !$target.classList.contains("animate") ){
				$target.classList.add("animate");
			}
		}
		function deleteAnimate( $target ){
			if( $target.classList.contains("animate") ){
				$target.classList.remove("animate");
			}
		}
	},
	checkScroll: function(){
		let s 		= scroll;
		let $html 	= document.documentElement;
		let top 	= s.position[0];
		let scrolledPos = 0;
		if( s.currentPage === "top" ){
			if( document.querySelector("#b-content_top") ){
				scrolledPos = Math.floor( document.querySelector("#b-content_top").getBoundingClientRect().top + window.pageYOffset )
			}
		}
		if( top > scrolledPos ){
			if( !$html.classList.contains("scrolled") ){
				$html.classList.add("scrolled");
			}
		}else{
			if( $html.classList.contains("scrolled") ){
				$html.classList.remove("scrolled");
			}
		}
		/*
		if( scroll.currentPage === "philosophy" ){
			if( top < window.innerHeight ){
				let $firstNav = document.querySelectorAll("[data-scroll]")[0];
				if( !$firstNav.classList.contains("active") ){
					document.querySelectorAll("data-scroll").forEach( ($n, index) => {
						$n.classList.remove("active");
					});
					$firstNav.classList.add("active");
				}
			}
		}
		*/
		//console.log(s.position);
	},
	goTo: function(  ){
		
	},
	reActive: function(){
		//console.log("reactive scroll");
		this.start();
	},
	getTop($dom, offset){
		let t = Math.floor( $dom.getBoundingClientRect().top + window.pageYOffset );
		return [ t, Math.floor( t + offset )]
	},
	goToPos(e){
		e.preventDefault();
		let $this 	= this.name;
		let id 		= e.currentTarget.getAttribute("href");
		setTimeout(function(){
			let posY = Math.floor( document.querySelector(id).getBoundingClientRect().top + window.pageYOffset );
			//console.log(id, posY, window.pageYOffset, $this.navStopPos);
			let options = {
				duration: 1
			}
			$this.lenis.scrollTo(posY, options);
		}, 100);
		
		//console.log(id, posY, $this.lenis);
	},
	checkPhilosophy: function(items){
		items.forEach( (item) => {
			if( item.isIntersecting ){
				startAnimate( item.target );
			}else{
				if( item.target.getAttribute("data-repeat") === "1" ){
					deleteAnimate(item.target);
					
				}
			}
		});
		
		function startAnimate( $target ){
			let $targetBlock = $target.parentElement.parentElement.parentElement;
			
			if( !$targetBlock.classList.contains("active") ){
				$targetBlock.classList.add("active");
			}
			let $navs = document.querySelectorAll(".c-nav_philosophy li a");
			if( $targetBlock.getAttribute("id") ){
				let $targetID = "#" + $targetBlock.getAttribute("id");
				$navs.forEach( ($n, index) => {
					let thisID = $n.getAttribute("href");
					if( thisID === $targetID ){
						$n.classList.add("active");
					}else{
						if( $n.classList.contains("active") ){
							$n.classList.remove("active");
						}
					}
				});
			}else{
				$navs.forEach( ($n, index) => {
					if( index === 0){
						$n.classList.add("active");
					}else{
						if( $n.classList.contains("active") ){
							$n.classList.remove("active");
						}
					}
				});
			}
			
		}
		function deleteAnimate( $target ){
			if( $target.classList.contains("active") ){
				$target.classList.remove("active");
			}
		}
	},
	checkPosition: function(){
		let $this 	= this;
		let hash 	= location.hash;
		if( hash != "" ){
			let posY = Math.floor( document.querySelector(hash).getBoundingClientRect().top + window.pageYOffset );
			//console.log(id, posY, window.pageYOffset, $this.navStopPos);
			let options = {
				duration: .6
			}
			$this.lenis.scrollTo(posY, options);
		}
	}
}